import { createSelector } from '@ngrx/store';

import { selectConfigStripState } from './config-strip.feature.selector';

export const selectPrefilledDelivery = createSelector(
  selectConfigStripState,
  (state) => state.business.prefilledDeliveryItems,
);

export const selectPrefilledDeliveryItemsCategory = createSelector(
  selectPrefilledDelivery,
  (prefilledDelivery) => prefilledDelivery.category,
);

export const selectMasterQuantity = createSelector(
  selectPrefilledDelivery,
  (prefilledDelivery) => prefilledDelivery.masterQuantities,
);

export const selectPrefilledVisible = createSelector(
  selectPrefilledDelivery,
  (prefilledDelivery) => prefilledDelivery.visible,
);
